<template>
    <div
        class="height-transition"
        :class="{
            'open': open,
            'display-overflow': displayOverflow && !overrideOverflow,
        }"
        :inert="!open"
    >
        <div class="container">
            <slot />
        </div>
    </div>
</template>
<script>
export default {
    name: 'HeightTransition',
    props: {
        open: {
            type: Boolean,
            required: false,
            default: false,
        },
        overrideOverflow: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data: () => ({
        displayOverflow: false,
    }),
    watch: {
        open (to) {
            if (to === true) {
                setTimeout(() => {
                    this.displayOverflow = true;
                }, 500);
            } else {
                this.displayOverflow = false;
            }
        },
    },
    mounted() {
        if (this.open) {
            setTimeout(() => {
                this.displayOverflow = true;
            }, 500);
        } else {
            this.displayOverflow = false;
        }
    },
};
</script>
<style scoped>
.height-transition {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 0fr;
  will-change: grid-template-rows;
  transition: all 0.5s ease-in-out;
}
.height-transition > .container {
  overflow: hidden;
  opacity: 0;
  transition: 0.5s ease-in-out;
}
.height-transition.display-overflow > .container {
  max-width: 100%;
  overflow-y: visible;
}
.height-transition.open {
  grid-template-rows: 1fr;
}
.height-transition.open > .container {
  opacity: 1;
}
</style>
